module.exports = __webpack_public_path__ + "static/img/2.ead363e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/2.jpg
// module id = xMQm
// module chunks = 1